// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c798de1","721":"6397d829"}[chunkId] + ".chunk.js";
};